import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import {Row, Col, Card, Tabs} from 'antd';
import request from 'superagent';
import moment from 'moment';
import AlertAnt from './AlertAnt.js';
import PlatformAlertAnt from './PlatformAlertAnt.js';
import NginxRequestChart from './NginxRequestChart.js';
import TopServerChart from './TopServerChart.js';
import SystemUsageStatistics from './SystemUsageStatistics.js';
import VirtualMachineCardList from './VirtualMachineCardList.js';
import NginxRequestChartPopup from './NginxRequestChartPopup.js';
import TopServerChartPopup from './TopServerChartPopup.js';
import AlertConfiguration from './alert-configuration/AlertConfiguration.js';
import PDMSServiceAlertAnt from './PDMSServiceAlertAnt.js';

import {permissionCtrlHOC} from "../../commons/CommonUtils";
import {Permissions} from "../../commons/Constants";

const TabPane = Tabs.TabPane;

function callback(key) {
    /*console.log(key);*/
}

class DashboardViewAnt extends Component {

    cookie = new Cookies();

    constructor(props) {
        super(props);
        this.state = {
            alertConfiguration: false,
            data: [],
            vmData: [],
            selectVM: [],
            ctData: [],
            paData: [],
            errorCount: 0,
            fatalCount: 0,
            loading: false,
            intervalId: 0
        };
    }

    componentDidMount() {
        this.fetch('load');
        let intervalId = setInterval(this.fetch, 30 * 60 * 1000);
        this.setState({intervalId: intervalId});
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    fetch = (params) => {
        if (params && params === 'load') {
            this.setState({loading: true});
        }
        request.get('/api/dashboard/platform/info')
            .withCredentials()
            .end((error, response) => {
                if (!error && response) {
                    let data = response.body;
                    let vmArray = [];
                    let containerArray = [];
                    let countE = 0;
                    let countF = 0;
                    let platformAlertArray = [];
                    let countEPDMS = 0;
                    let countFPDMS = 0;
                    let platformAlertArrayPDMS = [];
                    for (let i = 0; i < data.length; i++) {
                        data[i].level = data[i].level.toUpperCase();
                        data[i].appName = data[i].appName.toUpperCase();
                        data[i].resourceType = data[i].resourceType.toUpperCase();
                        data[i].used_percent = Math.round(data[i].used_percent);
                        data[i].startTime4Show = moment(data[i].startTime).format("YYYY-MM-DD HH:mm:ss");
                        if (!data[i].containerID) {
                            data[i].containerID = '';
                        }
                        if (data[i].resourceType === 'CPU') {
                            vmArray.push(data[i]);
                        }
                        if (data[i].resourceType === 'DOCKER_CONTAINER_CPU') {
                            containerArray.push(data[i]);
                        }
                        if (data[i].appName === 'PDMS') {
                            if (data[i].level === 'FATAL') {
                                countFPDMS += 1;
                                data[i].levelPa = 'Alarm';
                                platformAlertArrayPDMS.push(data[i]);
                            } else if (data[i].level === 'ERROR') {
                                countEPDMS += 1;
                                data[i].levelPa = 'Warning';
                                platformAlertArrayPDMS.push(data[i]);
                            }
                        } else {
                            if (data[i].level === 'FATAL') {
                                countF += 1;
                                data[i].levelPa = 'Alarm';
                                platformAlertArray.push(data[i]);
                            } else if (data[i].level === 'ERROR') {
                                countE += 1;
                                data[i].levelPa = 'Warning';
                                platformAlertArray.push(data[i]);
                            }
                        }
                    }

                    // organize vm data
                    let vmData = [];
                    for (let i = 0; i < vmArray.length; i++) {
                        let vmTemp = {
                            hostName: vmArray[i].hostName,
                            cpu: vmArray[i].used_percent,
                            cpuLevel: vmArray[i].level,
                            container: [],
                            alert: [],
                            containerAlert: []
                        }
                        if (vmArray[i].description !== '') {
                            vmTemp.alert.push(vmArray[i].description);
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'DISK') {
                                vmTemp.disk = data[j].used_percent;
                                vmTemp.diskLevel = data[j].level;
                                if (data[j].description !== '') {
                                    vmTemp.alert.push(data[j].description);
                                }
                            } else if (data[j].hostName === vmTemp.hostName && data[j].resourceType === 'MEM') {
                                vmTemp.memory = data[j].used_percent;
                                vmTemp.memoryLevel = data[j].level;
                                if (data[j].description !== '') {
                                    vmTemp.alert.push(data[j].description);
                                }
                            } else if (data[j].hostName === vmTemp.hostName && (data[j].resourceType === 'DOCKER_CONTAINER_CPU' || data[j].resourceType === 'DOCKER_CONTAINER_MEM')) {
                                if (!vmTemp.container.includes(data[j].containerID)) {
                                    vmTemp.container.push(data[j].containerID);
                                }
                                if (data[j].description !== '') {
                                    vmTemp.containerAlert.push(data[j].description);
                                }
                            }
                        }
                        vmTemp.container4show = vmTemp.container.toString();
                        vmTemp.containerCount = vmTemp.container.length;
                        vmTemp.alertCount = vmTemp.alert.length + vmTemp.containerAlert.length;
                        vmData.push(vmTemp);
                    }

                    // organize container data
                    let ctData = [];
                    for (let i = 0; i < containerArray.length; i++) {
                        let containerTypeIndex = containerArray[i].containerType.indexOf('/');
                        let ctTemp = {
                            hostName: containerArray[i].hostName,
                            containerID: containerArray[i].containerID,
                            cpu: containerArray[i].used_percent,
                            cpuLevel: containerArray[i].level,
                            containerType: containerArray[i].containerType.substring(containerTypeIndex),
                            memory: '',
                            alert: []
                        }
                        if (containerArray[i].description !== '') {
                            ctTemp.alert.push(containerArray[i].description);
                        }
                        for (let j = 0; j < data.length; j++) {
                            if (data[j].hostName === ctTemp.hostName && data[j].containerID === ctTemp.containerID && data[j].resourceType === 'DOCKER_CONTAINER_MEM') {
                                ctTemp.memory = data[j].used_percent;
                                ctTemp.memoryLevel = data[j].level;
                                if (data[j].description !== '') {
                                    ctTemp.alert.push(data[j].description);
                                }
                            }
                        }
                        ctTemp.alertCount = ctTemp.alert.length;
                        ctData.push(ctTemp);
                    }

                    // organize alert data
                    for (let i = 0; i < platformAlertArray.length; i++) {
                        if (platformAlertArray[i].servers && platformAlertArray[i].servers.length > 0) {
                            platformAlertArray[i].serviceName = platformAlertArray[i].servers[0].ServiceID.split(':')[0];
                            platformAlertArray[i].serviceStatus = platformAlertArray[i].servers[0].Status;
                        } else {
                            platformAlertArray[i].serviceName = '';
                            platformAlertArray[i].serviceStatus = '';
                        }
                    }
                    for (let i = 0; i < platformAlertArrayPDMS.length; i++) {
                        if (platformAlertArrayPDMS[i].servers && platformAlertArrayPDMS[i].servers.length > 0) {
                            platformAlertArrayPDMS[i].serviceName = platformAlertArrayPDMS[i].servers[0].ServiceID.split(':')[0];
                            platformAlertArrayPDMS[i].serviceStatus = platformAlertArrayPDMS[i].servers[0].Status;
                        } else {
                            platformAlertArrayPDMS[i].serviceName = '';
                            platformAlertArrayPDMS[i].serviceStatus = '';
                        }
                    }

                    // set select vm in cookie
                    let selectVMCookie = this.cookie.get('selectVM');
                    let selectVM = [];
                    if (selectVMCookie !== undefined) {
                        let tmpVM = [];
                        tmpVM = selectVMCookie.split(';');
                        for (let i = 0; i < tmpVM.length; i++) {
                            for (let j = 0; j < vmData.length; j++) {
                                if (tmpVM[i] === vmData[j].hostName) {
                                    selectVM.push(vmData[j]);
                                }
                            }

                        }
                    } else {
                        selectVM.push(vmData[0]);
                        selectVM.push(vmData[1]);
                        selectVM.push(vmData[2]);
                        let tmpVM = vmData[0].hostName + ';' + vmData[1].hostName + ';' + vmData[2].hostName;
                        this.cookie.set('selectVM', tmpVM, {expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)});
                    }

                    this.setState({
                        data: data,
                        vmData: vmData,
                        paData: platformAlertArray,
                        errorCount: countE,
                        fatalCount: countF,
                        paDataPDMS: platformAlertArrayPDMS,
                        errorCountPDMS: countEPDMS,
                        fatalCountPDMS: countFPDMS,
                        selectVM: selectVM,
                        ctData: ctData
                    });
                    if (params && params === 'load') {
                        this.setState({loading: false});
                    }
                } else {
                    if (params && params === 'load') {
                        this.setState({loading: false});
                    }
                }
            });
    }

    redirectToSystemUsage = (e) => {
        e.preventDefault();
        this.props.history.push('/main/systemUsage');
    }

    changeToConfiguration = () => {
        this.setState({alertConfiguration: true});
    }

    backToDashboard = () => {
        this.setState({alertConfiguration: false});
    }

    unPinVM = (hostName) => {
        let selectVMCookie = this.cookie.get('selectVM');
        let selectVM = this.state.selectVM;
        if (selectVMCookie) {
            let tmpVM = selectVMCookie.split(';');
            tmpVM = tmpVM.filter((vm) => {
                return vm !== hostName;
            });
            let tmpVMCookie = '';
            for (let i = 0; i < tmpVM.length; i++) {
                tmpVMCookie = tmpVMCookie + tmpVM[i] + ';';
            }
            tmpVMCookie = tmpVMCookie.substring(0, tmpVMCookie.length - 1);
            this.cookie.set('selectVM', tmpVMCookie, {expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)});

            selectVM = selectVM.filter((vm) => {
                return vm.hostName !== hostName;
            });
            this.setState({selectVM: selectVM});
        }
    }

    render() {
        const vmData = this.state.vmData;
        const selectVM = this.state.selectVM;
        const ctData = this.state.ctData;
        const loading = this.state.loading;
        const paData = this.state.paData;
        const errorCount = this.state.errorCount;
        const fatalCount = this.state.fatalCount;
        const paDataPDMS = this.state.paDataPDMS;
        const errorCountPDMS = this.state.errorCountPDMS;
        const fatalCountPDMS = this.state.fatalCountPDMS;
        const alertConfiguration = this.state.alertConfiguration;

        return (
            <div className="page-container">
                <div style={{display: alertConfiguration === false ? 'block' : 'none'}}>
                    <h2 className="page-title">Dashboard</h2>
                    {<Row gutter={10}>
                        <Col span={12}>
                            <Card title="Front End Server Requests" extra={<NginxRequestChartPopup/>} bodyStyle={{padding: 10}}>
                                <NginxRequestChart/>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card title="Top 5 Servers CPU Occupancy" extra={<TopServerChartPopup/>} bodyStyle={{padding: 10}}>
                                <TopServerChart/>
                            </Card>
                        </Col>
                    </Row>}
                    <Row gutter={10} style={{paddingTop: 10, marginTop: 10, marginBottom: 15}}>
                        <Col span={6} onClick={this.redirectToSystemUsage}>
                            <SystemUsageStatistics vmData={vmData} ctData={ctData}/>
                        </Col>
                        <Col span={18}>
                            <VirtualMachineCardList vmData={selectVM} unPinVM={this.unPinVM} redirectToSystemUsage={this.redirectToSystemUsage} loading={loading}/>
                        </Col>
                    </Row>
                    <Row style={{paddingTop: 10}}>
                        <Col span={24}>
                            <Card bodyStyle={{padding: 10}}>
                                <Tabs onChange={callback} type="card" tabBarExtraContent={permissionCtrlHOC([Permissions.SystemUsage.CONFIG])(<a href="#" style={{display:'none'}} onClick={this.changeToConfiguration}>Configuration</a>)}>
                                    <TabPane tab="Service Alert" key="1"><AlertAnt/></TabPane>
                                    <TabPane tab="Platform Alert" key="2"><PlatformAlertAnt paData={paData} errorCount={errorCount} fatalCount={fatalCount} loading={loading} /></TabPane>
                                    <TabPane tab="PDMS Service Alert" key="3"><PDMSServiceAlertAnt/></TabPane>
                                    <TabPane tab="PDMS Platform Alert" key="4"><PlatformAlertAnt paData={paDataPDMS} errorCount={errorCountPDMS} fatalCount={fatalCountPDMS} loading={loading} /></TabPane>
                                </Tabs>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div style={{display: alertConfiguration === true ? 'block' : 'none'}}>
                    <AlertConfiguration backToDashboard={this.backToDashboard}/>
                </div>
            </div>

        );
    }
}

export default DashboardViewAnt;


// WEBPACK FOOTER //
// ./src/modules/dashboard/DashboardViewAnt.js